const Card = (props) => {
    return (
        <div className="card w-96 bg-base-100 shadow-xl md:mr-2">
            <img src={props.img} alt="#" />
            <div className="card-body">
                <h2 className="card-title">{props.title}</h2>
                <p>{props.details}</p>
                <div className="card-actions justify-start">
                    <button>{props.text}</button>
                </div>
            </div>
        </div>
    );
};

export default Card;


// const Card = (props) => {
//     return (
//         <div>
//             <img src={props.img} alt="#" />
//             <h1>{props.title}</h1>
//             <p>{props.details}</p>
//             <button>{props.text}</button>
//         </div>
//
//     );
// };
